import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hei',
  templateUrl: './hei.component.html',
  styleUrls: ['./hei.component.scss']
})
export class HeiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
